import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

// import CloudProviderBarSkeleton from '@root/components/v2/content/CloudProviderBar/skeleton';
import PageContainer from '@root/components/v2/layout/PageContainer';
import PageContent from '@root/components/v2/layout/PageContent';
import ContentBox from '@root/components/v2/content/ContentBox';
import TableSkeleton from '@root/components/table/skeleton';

export const TopRowASkeleton = () => {
  return (
    <Grid container direction="row" spacing={1.2} sx={{ flexWrap: 'nowrap', marginBottom: '15px' }}>
      <Grid item container direction="row" xs={6} spacing={1.2}>
        <Grid item xs={4}>
          <ContentBox
            style={{
              height: '206px',
              display: 'flex',
              padding: '61px 15px',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Skeleton variant="rectangular" height={'90px'} width={'70%'} />
          </ContentBox>
        </Grid>
        <Grid item xs={8}>
          <ContentBox
            title={<>OKTA DEPROVISIONED OR Inactive Users with Access to User account </>}
            titleSize="medium"
            padding="0px"
            titleContainerStyle={{
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              borderBottom: '1px solid #CBD5E0',
              padding: '0px 31px 0px 15px',
              margin: '0px',
              height: '40px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Manrope',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: 'normal',
            }}
            containerClassName={'border-box-no-pad'}
            paddingMode="content"
            style={{
              height: '206px',
              display: 'flex',
              paddingBottom: '50px',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '50px',
            }}>
            <Skeleton variant="rectangular" height={'60px'} width={'70%'} />
          </ContentBox>
        </Grid>
      </Grid>
      <Grid item container direction="row" xs={6} spacing={1.2}>
        <Grid item xs={4}>
          <ContentBox
            style={{
              height: '206px',
              display: 'flex',
              padding: '71.5px 15px',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Skeleton variant="rectangular" height={'90px'} width={'70%'} />
          </ContentBox>
        </Grid>
        <Grid item xs={8}>
          <ContentBox
            title={<>Okta User Inactive for More Than 90 Days</>}
            titleSize="medium"
            padding="0px"
            titleContainerStyle={{
              // fontSize: '16px !important',
              width: '100%',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              borderBottom: '1px solid #CBD5E0',
              padding: '0px 31px 0px 15px',
              margin: '0px',
              display: 'flex',
              alignItems: 'center',
              height: '40px',
              fontFamily: 'Manrope',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: 'normal',
            }}
            containerClassName={'border-box-no-pad'}
            paddingMode="content"
            style={{
              height: '206px',
              display: 'flex',
              paddingBottom: '50px',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '50px',
            }}>
            <Skeleton variant="rectangular" height={'60px'} width={'70%'} />
          </ContentBox>
        </Grid>
      </Grid>
    </Grid>
  );
};

function IdPSkeleton() {
  return (
    <PageContainer>
      <PageContent>
        {/* <CloudProviderBarSkeleton /> */}

        <ContentBox
          style={{
            marginBottom: '15px',
            width: '100%',
            height: '100%',
          }}>
          <Box className="Borders RoundedCorners" marginTop="15px" marginBottom="15px">
            <Skeleton height="40px" style={{ transform: 'none' }} />
          </Box>
          <Box height={'63.7vh'}>
            <TableSkeleton COLUMNS_COUNT={12} />
          </Box>
        </ContentBox>
      </PageContent>
    </PageContainer>
  );
}

export default IdPSkeleton;
